// src/loggerImplementations/LoggerEnums.ts
var LoggerName = /* @__PURE__ */ ((LoggerName2) => {
  LoggerName2["PINO"] = "pino";
  LoggerName2["CONSOLE"] = "console";
  return LoggerName2;
})(LoggerName || {});
var LogLevel = /* @__PURE__ */ ((LogLevel2) => {
  LogLevel2["INFO"] = "info";
  LogLevel2["DEBUG"] = "debug";
  LogLevel2["WARN"] = "warn";
  LogLevel2["ERROR"] = "error";
  return LogLevel2;
})(LogLevel || {});

// src/loggerImplementations/BrowserLogger.ts
var BrowserLogger = class {
  logger;
  /**
   * Creates an instance of Logger.
   * Initializes the underlying logger implementation based on the provided option.
   *
   * @constructor
   * @remarks If an invalid loggerOption is provided, a warning message will be logged and
   * the default PinoLogger will be initialized.
   */
  constructor() {
    this.logger = console;
  }
  /**
   * Internal method to log messages at a specific level.
   * Uses the configured logger, falling back to console.log if an error occurs.
   *
   * @param {LogLevel} level - The severity level of the log.
   * @param {string} message - The message to log.
   * @param {Record<string, unknown>} data - Additional data to accompany the message.
   */
  log(level, message, data) {
    this.logger[level]({
      level,
      message,
      data,
      timestamp: (/* @__PURE__ */ new Date()).toISOString()
    });
  }
  /**
   * Logs a message at the info level.
   * @param {string} message - The message to log.
   * @param {Record<string, unknown>} data - Additional data to log.
   */
  info(message, data = {}) {
    this.log("info" /* INFO */, message, data);
  }
  /**
   * Logs a message at the debug level.
   * @param {string} message - The message to log.
   * @param {Record<string, unknown>} data - Additional data to log.
   */
  debug(message, data = {}) {
    this.log("debug" /* DEBUG */, message, data);
  }
  /**
   * Logs a message at the warn level.
   * @param {string} message - The message to log.
   * @param {Record<string, unknown>} data - Additional data to log.
   */
  warn(message, data = {}) {
    this.log("warn" /* WARN */, message, data);
  }
  /**
   * Logs a message at the error level.
   * @param {string} message - The message to log.
   * @param {Record<string, unknown>} data - Additional data to log.
   * @returns {Promise<void>} A promise that resolves when the message is logged.
   */
  error(message, data = {}) {
    this.log("error" /* ERROR */, message, data);
  }
  /**
   * Returns the name of the underlying logger used.
   */
  getLoggerName() {
    return "console" /* CONSOLE */;
  }
};

// src/BrowserLambdaLogger.ts
var BrowserLambdaLogger = class _BrowserLambdaLogger extends BrowserLogger {
  static instance = null;
  constructor() {
    super();
  }
  // Simplified to browser-only behavior
  static getInstance() {
    if (!_BrowserLambdaLogger.instance) {
      const loggerInstance = new _BrowserLambdaLogger();
      _BrowserLambdaLogger.instance = loggerInstance;
    }
    return _BrowserLambdaLogger.instance;
  }
  // Simplified to browser-only behavior
  static resetInstance() {
  }
  // Simplified to browser-only behavior
  static setConfig() {
    return;
  }
  /**
   * Binds the current execution context and the event details to the logger instance
   * to enable automatic request tracing.
   * @param event - Lambda event object.
   * @param context - Lambda context object.
   */
  setLambdaContext(event, context) {
    console.warn("ignoring setLambdaContext called im browser", {
      event,
      context
    });
    return;
  }
};
export {
  BrowserLambdaLogger as LambdaLogger,
  LogLevel,
  BrowserLogger as Logger,
  LoggerName
};
//# sourceMappingURL=browser.js.map
